import { Column } from '../../../common/interfaces';
import { Filter, FilterUI } from './types';
import { FilterCondition } from '../../../common/classes/Filter/FilterCondition';
import { AsyncStatus, ColumnType } from '../../../common/enums';

export const transformFiltersToFiltersUI = (filterList: Filter[] | undefined, fields: Column[] = []): FilterUI[] => {
    if (!filterList || filterList.length === 0) {
        return [];
    }
    return filterList.map((filter) => {
        const filterConditions =
            fields.length > 0
                ? filter.conditions.map((condition) => new FilterCondition(fields, condition).toDisplayModel())
                : filter.conditions.map((condition) => ({
                      ...condition,
                      columnType: condition.columnType,
                      isValid: true,
                      enableValue: true,
                      isFieldValid: true,
                      isDateType: false,
                      isValueValid: true,
                      isOperatorValid: true,
                      isConditionEmpty: false,
                      disableDeleteCondition: false,
                      doesFieldExist: true,
                  }));

        return {
            ...filter,
            isNewFilter: false,
            isDuplicateFilter: false,
            isValid: true,
            isFilterEmpty: false,
            disableAddCondition: false,
            disableDeleteCondition: false,
            conditions: filterConditions,
        };
    }) as FilterUI[];
};

export const isReportLoading = (status: AsyncStatus): boolean => status === AsyncStatus.IN_PROGRESS || status === AsyncStatus.NOT_STARTED;

/**
 * Maps API dataType to ColumnType enum values for filter operations
 */
export const mapApiDataTypeToColumnType = (apiDataType: string, defaultType?: string): ColumnType => {
    switch (apiDataType) {
        case 'TEXT':
            return ColumnType.TEXT_NUMBER;
        case 'USERREF':
            return ColumnType.CONTACT_LIST;
        case 'DATETIME':
            return ColumnType.DATETIME;
        case 'PICKLIST':
            return ColumnType.PICKLIST;
        case 'MULTIPICKLIST':
            return ColumnType.MULTI_PICKLIST;
        case 'CHECKBOX':
        case 'BOOLEAN':
            return ColumnType.CHECKBOX;
        case 'DATE':
            return ColumnType.DATE;
        case 'DURATION':
            return ColumnType.DURATION;
        case 'MULTIUSERLIST':
            return ColumnType.MULTI_CONTACT_LIST;
        default:
            return apiDataType as ColumnType;
    }
};

/**
 * Transform API columns to Column interface with proper type mapping
 */
export const transformApiColumnsToColumns = (apiColumns: any[]): Column[] => {
    if (!apiColumns || !Array.isArray(apiColumns)) {
        return [];
    }

    return apiColumns.map((col: any) => {
        const mappedType = mapApiDataTypeToColumnType(col.dataType, col.defaultType);

        return {
            ...col,
            type: mappedType,
        };
    });
};
